import useSidebar from "hooks/useSidebar";

export default function MobileOverlay() {
  const { isMobileOpen, closeMobile } = useSidebar();

  return (
    <div
      onClick={closeMobile}
      className={`fixed inset-0 z-30 bg-slate-950/40 backdrop-blur-[1px] transition-opacity duration-300 md:hidden ${
        isMobileOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
      }`}
    />
  );
}
